// extracted by mini-css-extract-plugin
export default {"container":"NavigationTab_container__w4NlZ","disabled":"NavigationTab_disabled__yHaxj","label":"NavigationTab_label__NW4Ny","isSelected":"NavigationTab_isSelected__yCqtH"};